import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Admin.css';

function Admin() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  const [songs, setSongs] = useState([]);
  const [title, setTitle] = useState('');
  const [artist, setArtist] = useState('');
  const [youtube_link, setYoutubeLink] = useState('');
  const [slowed_link, setSlowedLink] = useState('');
  const [superslowed_link, setSuperslowedLink] = useState('');
  const [cover_image_url, setCoverImageUrl] = useState('');/* Admin Panel Dark Theme */
  const [searchTerm, setSearchTerm] = useState('');
  const [editingSongId, setEditingSongId] = useState(null);
  const [currentSong, setCurrentSong] = useState({});

  useEffect(() => {
    fetchSongs();
  }, []);

  const fetchSongs = (query = '') => {
    const url = query ? `https://backend.viralphonks.com:443/songs?search=${query}` : 'https://backend.viralphonks.com:443/songs';
    fetch(url)
      .then((response) => response.json())
      .then((data) => setSongs(data))
      .catch((error) => console.error('Error fetching songs:', error));
  };

  const handleSearch = (e) => {
      e.preventDefault();
      fetchSongs(searchTerm);
  }

  const handleAddSong = (e) => {
    e.preventDefault();
    const newSong = { title, artist, youtube_link, slowed_link, superslowed_link, cover_image_url };
    fetch('https://backend.viralphonks.com:443/songs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newSong),
    })
      .then(response => response.json())
      .then(data => {
        setSongs([...songs, data]);
        setTitle('');
        setArtist('');
        setYoutubeLink('');
        setSlowedLink('');
        setSuperslowedLink('');
        setCoverImageUrl('');
      })
      .catch(error => console.error('Error adding song:', error));
  };

  const handleDeleteSong = (id) => {
      fetch(`https://backend.viralphonks.com:443/songs/${id}`, {
          method: 'DELETE',
      })
      .then(() => {
          setSongs(songs.filter(song => song.id !== id));
      })
      .catch(error => console.error('Error deleting song:', error));
  }

  const handleTrendUpdate = (id, is_trending) => {
    fetch(`https://backend.viralphonks.com:443/songs/${id}/trending`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_trending: !is_trending }),
    })
    .then(() => {
        const updatedSongs = songs.map(song => 
            song.id === id ? { ...song, is_trending: !is_trending } : song
        );
        setSongs(updatedSongs);
    })
    .catch(error => console.error('Error updating trend status:', error));
  };

  const handleNewUpdate = (id, is_new) => {
    fetch(`https://backend.viralphonks.com:443/songs/${id}/is_new`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_new: !is_new }),
    })
    .then(() => {
        const updatedSongs = songs.map(song => 
            song.id === id ? { ...song, is_new: !is_new } : song
        );
        setSongs(updatedSongs);
    })
    .catch(error => console.error('Error updating new status:', error));
  };

  const handleEditClick = (song) => {
    setEditingSongId(song.id);
    setCurrentSong(song);
    setTitle(song.title);
    setArtist(song.artist);
    setYoutubeLink(song.youtube_link);
    setSlowedLink(song.slowed_link);
    setSuperslowedLink(song.superslowed_link);
    setCoverImageUrl(song.cover_image_url);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setEditingSongId(null);
    setCurrentSong({});
    setTitle('');
    setArtist('');
    setYoutubeLink('');
    setSlowedLink('');
    setSuperslowedLink('');
    setCoverImageUrl('');
  };

  const handleUpdateSong = (e) => {
    e.preventDefault();
    const updatedSong = { ...currentSong, title, artist, youtube_link, slowed_link, superslowed_link, cover_image_url };
    fetch(`https://backend.viralphonks.com:443/songs/${editingSongId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedSong),
    })
      .then(response => response.json())
      .then(data => {
        setSongs(songs.map(song => (song.id === editingSongId ? data : song)));
        handleCancelEdit();
      })
      .catch(error => console.error('Error updating song:', error));
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        <h1>Admin Panel</h1>
        <button onClick={handleLogout} className="logout-button">Çıkış Yap</button>
      </header>
      
      <div className="admin-content">
        <div className="song-form-container">
          <h2 className="form-title">{editingSongId ? 'Edit Song' : 'Add New Song'}</h2>
          <form onSubmit={editingSongId ? handleUpdateSong : handleAddSong} className="song-form">
            <div className="form-group">
              <input type="text" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="text" placeholder="Artist" value={artist} onChange={(e) => setArtist(e.target.value)} />
            </div>
            <div className="form-group">
              <input type="text" placeholder="YouTube Link" value={youtube_link} onChange={(e) => setYoutubeLink(e.target.value)} required />
            </div>
            <div className="form-group">
              <input type="text" placeholder="Slowed Link" value={slowed_link} onChange={(e) => setSlowedLink(e.target.value)} />
            </div>
            <div className="form-group">
              <input type="text" placeholder="Super Slowed Link" value={superslowed_link} onChange={(e) => setSuperslowedLink(e.target.value)} />
            </div>
            <div className="form-group">
              <input type="text" placeholder="Cover Image URL" value={cover_image_url} onChange={(e) => setCoverImageUrl(e.target.value)} />
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-button">{editingSongId ? 'Update Song' : 'Add Song'}</button>
              {editingSongId && <button type="button" onClick={handleCancelEdit} className="cancel-button">Cancel</button>}
            </div>
          </form>
        </div>

        <div className="song-management">
          <h2 className="management-title">Manage Songs</h2>
          <form onSubmit={handleSearch} className="search-form">
            <input type="text" placeholder="Search by title or artist" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            <button type="submit" className="search-button">Search</button>
          </form>
          
          <div className="songs-list">
            <table className="songs-table">
              <thead>
                <tr>
                  <th>Cover</th>
                  <th>Song Info</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {songs.map(song => (
                  <tr key={song.id}>
                    <td className="cover-cell">
                      <img src={song.cover_image_url} alt={song.title} className="song-cover" />
                    </td>
                    <td className="info-cell">
                      <div className="song-title">{song.title}</div>
                      <div className="song-artist">{song.artist}</div>
                    </td>
                    <td className="actions-cell">
                      <div className="action-buttons">
                        <button 
                          onClick={() => handleTrendUpdate(song.id, song.is_trending)}
                          className={`trend-button ${song.is_trending ? 'active' : ''}`}
                        >
                          {song.is_trending ? 'Trendden Çıkar' : 'Trend Yap'}
                        </button>
                        <button 
                          onClick={() => handleNewUpdate(song.id, song.is_new)}
                          className={`new-button ${song.is_new ? 'active' : ''}`}
                        >
                          {song.is_new ? 'Yenilikten Çıkar' : 'Yeni Yap'}
                        </button>
                        <button onClick={() => handleEditClick(song)} className="edit-button">Düzenle</button>
                        <button 
                            onClick={() => {
                              const isConfirmed = window.confirm('Bu şarkıyı silmek istediğinize emin misiniz?');
                              if (isConfirmed) {
                                const isFinalConfirmation = window.confirm('Bu işlem geri alınamaz! Kesin silmek istiyor musunuz?');
                                if (isFinalConfirmation) {
                                  handleDeleteSong(song.id);
                                }
                              }
                            }} 
                            className="delete-button"
                          >
                            Sil
                          </button>

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
